import { createFileRoute } from '@tanstack/react-router';
import { RequestLogsTab } from '../../pages/dashboard/requests/RequestLogsTab';
import { parseDayParam } from '../../lib/requestLogs';

/** `?day=YYYY-MM-DD` pins the log to one UTC calendar day. It is how the
 *  Overview usage chart drills into the day whose bar was clicked, so the page
 *  keeps one owner of "your requests" instead of growing a second one. */
export interface UsageSearch {
  day?: string;
}

export const Route = createFileRoute('/dashboard/usage')({
  validateSearch: (search: Record<string, unknown>): UsageSearch => {
    const day = parseDayParam(search.day);
    return day ? { day } : {};
  },
  component: UsageRoute,
  staticData: { fullWidth: true },
});

function UsageRoute() {
  const { day } = Route.useSearch();
  return <RequestLogsTab day={day} />;
}
